import { AnyAction } from 'redux';
import { App, RsVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { Rechtsstreitigkeiten } from '../appState';
import { RsVermieterActions } from '../rs-vermietung-actions.service';

export const rechtsstreitigkeitenReducer = function (
  sectionState: Rechtsstreitigkeiten = null,
  action: AnyAction,
): Rechtsstreitigkeiten {
  switch (action.type) {
    case RsVermieterActions.RECHTSSTREITIGKEITEN_CHANGED: {
      return { anzahl: 0, vorhanden: action.payload };
    }
    case RsVermieterActions.ANZAHL_RECHTSSTREITIGKEITEN_CHANGED: {
      return { ...sectionState, anzahl: action.payload };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: RsVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.RS_VERMIETUNG && actionPayload.anzahlVorschaeden) {
        return {
          anzahl: actionPayload.anzahlVorschaeden,
          vorhanden: actionPayload.anzahlVorschaeden > 0,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
